import React from "react";
import CustomPopoverMui from "../../../../CustomPopoverMui/CustomPopoverMui";
import { Box, ListItemText, MenuItem } from "@material-ui/core";

const status = [
  "All Status",
  "Verified",
  "Pending",
  "Failed",
  "Not Found",
  "Needs Review",
];

const SelectStatusPopover = (props) => {
  const {
    popoverState,
    isStatusOpen,
    handleClose,
    changeStatusSelected,
    statusSelected,
  } = props;

  return (
    <CustomPopoverMui
      anchorEl={popoverState.anchorEl}
      handleClose={handleClose}
      open={isStatusOpen}
      id={isStatusOpen ? "simple-popover" : undefined}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          maxWidth: "280px",
          width: "100%",
          padding: "0.5rem",
        }}
      >
        {status.map((item) => (
          <MenuItem
            key={item}
            onClick={() => {
              handleClose();
              changeStatusSelected(item);
            }}
            style={{
              backgroundColor:
                statusSelected === item ? "#f0f5f0" : "transparent",
              borderRadius: statusSelected === item ? "8px" : "0",
              padding: "2px 16px",
            }}
          >
            <ListItemText primary={item} />
          </MenuItem>
        ))}
      </Box>
    </CustomPopoverMui>
  );
};

export default SelectStatusPopover;
